import ReferAFriend from './ReferAFriend.component';

export default ReferAFriend;